import { Injectable, computed, signal } from '@angular/core';

interface ActivePitcherState {
  gameId: string;
  pitcherId: string;
  startedAt: string;
  pitches: number;
}

@Injectable({ providedIn: 'root' })
export class SoftballPitchClockService {
  private readonly active = signal<ActivePitcherState | null>(null);

  readonly current = computed(() => this.active());

  start(gameId: string, pitcherId: string): void {
    this.active.set({ gameId, pitcherId, startedAt: new Date().toISOString(), pitches: 0 });
  }

  recordPitch(): void {
    this.active.update(s => (s ? { ...s, pitches: s.pitches + 1 } : s));
  }

  stop(): void {
    this.active.set(null);
  }
}
